<template>
	<div>
		<section class="mainsection">
			<div class="container" style="margin-top:20px;">
				<div class="row">
					<div class="col-md-3 d-sm-none d-md-block">
						<nav-bar-pelaporan active="pelaporan-pajak"></nav-bar-pelaporan>
					</div>
					<div class="col-sm-pull-12 col-md-9">
						<div class="row justify-content-center">
							<div class="col-lg-12">
								<card type="secondary" shadow header-classes="bg-white pb-5" class="border-0">
									<template>
										<h6 slot="header" class="modal-title text-success font-weight-bold"
											id="modal-title-default">
											Pelaporan Pajak
										</h6>
										<div class="d-block" v-if="checkAkses">
											<div class="alert alert-default">
												<strong>Informasi!</strong> :
												<ul>
													<li>
														Silahkan pilih Tahun Pelaporan Pajak.
													</li>
													<li>
														Pilih Masa Pajak yang ingin dilaporkan
													</li>
													<li>
														SPTPD akan muncul setelah Pelaporan Pajak telah di-input.
													</li>
												</ul>
											</div>
											<ValidationObserver v-slot="{ handleSubmit }">
												<form ref="form" @submit.stop.prevent="handleSubmit()">
													<div class="alert alert-danger" v-if="error_msg.length > 0">
														<strong>Warning!</strong> Perbaiki hasil input Anda :
														<ul>
															<li v-for="text in error_msg" :key="text">{{ text }}</li>
														</ul>
													</div>
													<div class="mb-5">
														<div class="row mb-2">
															<div class="col-md-12">
																<div class="row">
																	<div class="col-md-4 col-sm-12">
																		<ValidationProvider name="Tahun SPT"
																			rules="required" v-slot="{ errors }">
																			<label>Tahun Pajak </label>
																			<select class="form-control"
																				name="collection_year" id="collection_year"
																				v-model="form.year"
																				:class="[{ 'is-valid': (!errors[0]) === true }, { 'is-invalid': (!errors[0]) === false }]"
																				@change="getData">
																				<option value disabled selected>--- Pilih
																					Tahun ---
																				</option>
																				<option :value="year.value"
																					v-for="year in optionYear"
																					:key="year.value">{{
																						year.text }}</option>
																			</select>
																			<div class="text-danger invalid-feedback"
																				style="display: block" v-if="errors[0]">{{
																					errors[0] }}
																			</div>
																		</ValidationProvider>
																	</div>
																</div>
															</div>
														</div>

														<div class="row">
															<div class="col-md-12">
																<div class="table-responsive-sm">
																	<table
																		class="table b-table table-hover table-bordered table-sm">
																		<thead>
																			<tr
																				class="tr-values vs-table--tr tr-table-state-null">
																				<th>Masa Pajak</th>
																				<th>Tanggal Pelaporan</th>
																				<th>Total Pajak</th>
																				<th>Status</th>
																				<th>Aksi</th>
																			</tr>
																		</thead>
																		<tbody>
																			<tr class="tr-values vs-table--tr tr-table-state-null"
																				v-for="(item, index) in data" :key="index">
																				<th>{{ list_month[item.masa_pajak] }}</th>
																				<td style="text-align: center;">{{
																					formatDate(item.tanggal_pelaporan) }}
																				</td>
																				<td style="text-align: right;">{{
																					item.total_pajak == '' ? '' :
																					formatMoney(
																						item.total_pajak
																					) }}</td>
																				<td>{{ item.status }}</td>
																				<td><a @click="goLaporPajak(item)"
																						v-if="item.request_update == 0"
																						class="btn btn-default text-white">Lapor
																						Pajak</a><a
																						@click="printSptpd(item)"
																						v-if="item.request_update == 1"
																						class="btn btn-success text-white">Cetak
																						SPTPD</a>
																					<a v-if="item.request_update == 1"
																						@click="requestUpdate(item)"
																						class="btn btn-warning text-white">Perbaiki</a>
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
															</div>
														</div>
													</div>
												</form>
											</ValidationObserver>
										</div>
										<div class="d-block" v-else>
											<div class="alert alert-default">
												<strong>Informasi!</strong> :
												<ul>
													<li>
														Harap login menggunakan email.
													</li>
													<li>
														Jika belum registrasi menggunakan email silahkan registrasi email
														Anda dan kemudian hubungkan email Anda di menu objek pajak ->
														hubungkan email.
													</li>
												</ul>
											</div>
										</div>
									</template>
								</card>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import navBarPelaporan from "./navBarPelaporan.vue"
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import axios from "axios";
import { formatMoney } from "accounting-js";
import moment from "moment";
import Swal from "sweetalert2";
export default {
	components: {
		PulseLoader,
		ValidationProvider,
		ValidationObserver,
		vSelect,
		navBarPelaporan
	},
	computed: {
		checkAkses() {
			if (this.$store.state.auth.status.loggedIn)
				return this.$store.state.auth.user.is_wajib_pajak;
			return false;
		},
		optionYear() {
			var i = 0;
			var optionsYear = [];
			let year = new Date().getFullYear();
			for (i = 2019; i <= year; i++) optionsYear.push({ value: i, text: i });
			return optionsYear;
		},
	},
	data() {
		return {
			list_month: {
				1: 'Januari',
				2: 'Febuary',
				3: 'Maret',
				4: 'April',
				5: 'Mei',
				6: 'Juni',
				7: 'Juli',
				8: 'Agustus',
				9: 'September',
				10: 'Oktober',
				11: 'November',
				12: 'Desember'
			},
			data: [],
			form: {
				year: null,
				id: []
			},
			isBusy: false,
			error_msg: [],
			edit: false,
		};
	},
	methods: {
		printSptpd(items) {
			try {
				const me = this;
				this.loading = true;
				axios({
					url: "/api/v2/taxes-reporting/sptpd" + "?id=" + items.id,
					method: "GET",
					responseType: "blob",
				})
					.then((response) => {
						var fileURL = window.URL.createObjectURL(new Blob([response.data]));
						var fileLink = document.createElement("a");
						fileLink.href = fileURL;
						fileLink.setAttribute(
							"download",
							"SPTPD_" +
							me.$store.state.auth.user.nik +
							'_' +
							items.thn_pajak +
							items.masa_pajak +
							".pdf"
						);
						document.body.appendChild(fileLink);
						fileLink.click();
						this.loading = false;
					})
					.catch((e) => {
						// console.log(e);
						this.loading = false;
					});
			} catch (e) {
				// console.log(e);
				this.loading = false;
			}
		},
		formatDate(date) {
			if (date == '' || date == null) return ''
			return moment(date).format('lll');
		},
		formatMoney(val) {
			return formatMoney(val, {
				symbol: "Rp. ",
				precision: 0,
				thousand: ".",
				decimal: ",",
			});
		},
		goLaporPajak(item) {
			this.$router.push('/pelaporan-pajak/create/' + item.thn_pajak + '/' + item.masa_pajak)
		},
		requestUpdate(item) {
			const me = this
			Swal.fire({
				title: "Apakah Anda yakin ingin ubah data ini?",
				showCancelButton: true,
				confirmButtonText: "Ya",
				denyButtonText: `Tidak`
			}).then((result) => {
				if (result.isConfirmed) {
					me.$router.push('/pelaporan-pajak/create/' + item.thn_pajak + '/' + item.masa_pajak)
				}
			});
		},
		async getData() {
			const me = this;
			try {
				let { data } = await axios.get(
					"/api/v2/taxes-reporting?year=" + this.form.year
				);
				this.data = []
				var currDate = new Date(); var currMonth = currDate.getMonth();
				var lastIndex = 12
				if (currDate.getFullYear() == this.form.year) {
					lastIndex = currMonth
				}
				for (let index = 1; index <= lastIndex; index++) {
					let taxes_reporting = data.find(obj => obj.month == index)
					this.data.push({
						thn_pajak: this.form.year,
						masa_pajak: index,
						tanggal_pelaporan: taxes_reporting != null ? taxes_reporting.created_at : '',
						total_pajak: taxes_reporting != null ? taxes_reporting.total_tax : '',
						status: taxes_reporting != null ?
							taxes_reporting.status == 1 ?
								'Sudah Lapor Pajak'
								: taxes_reporting.status == 2 ? 'Perbaikan' : 'Belum Lapor Pajak'
							: 'Belum Lapor Pajak',
						request_update: taxes_reporting != null ? taxes_reporting.status : 0,
						id: taxes_reporting != null ? taxes_reporting.id : 0,
					})

				}
			} catch (error) {
				this.isBusy = false;
				me.error_msg = ['Internal Server Error'];
			} finally {
				this.isBusy = false;
			}
		},
	},
};
</script>
<style></style>
